import dayjs from "dayjs";

export const dateTimeToDateAndTime = (dateTime: string) => {
  return { date: dateTime, time: dateTime };
};

export const dateAndTimeToDateTime = (date: string, time: string): string => {
  const parsedDate = dayjs(date);
  const parsedTime = dayjs(time);

  if (!parsedDate.isValid() || !parsedTime.isValid()) {
    throw new Error("Invalid date or time format");
  }

  // Combine date and time parts
  const combinedDateTime = dayjs(
    `${parsedDate.format("YYYY-MM-DD")}T${parsedTime.format("HH:mm:ss")}`
  );

  return combinedDateTime.toISOString();
};
